import defaultTheme from './default';
import {useAlign, useDeviceSize} from './helpers';
import {Theme} from './interface';
import {themeSelector} from '../../redux/selectors/runtime/theme';
import {useSelector} from 'react-redux';

export const useTheme = (): Theme => {
  const align = useAlign();
  const themeSettings = useSelector(themeSelector());
  const deviceSize = useDeviceSize();

  return defaultTheme(align, themeSettings, deviceSize);
};
